import React, { useState } from "react";
import { Link } from "react-router-dom";
import { postLoginHref } from "../../lib/djangoAppUrl";
import { apiFetch } from "../../lib/http";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);

    try {
      const resp = await apiFetch("/api/auth/login/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password })
      });

      const data = await resp.json().catch(() => ({}));
      if (!resp.ok) {
        setError(data?.error || "Invalid email or password.");
        setBusy(false);
        return;
      }

      window.location.href = postLoginHref();
    } catch {
      setError("Login failed.");
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-slate-950 text-slate-50 text-[15px] selection:bg-cyan-400/30 selection:text-cyan-50">
      <div className="mx-auto max-w-md min-h-screen flex flex-col">
        <main className="flex flex-1 items-center justify-center px-4 py-6">
          <section className="w-full rounded-3xl bg-slate-900/40 ring-1 ring-cyan-300/25 p-5">
            <header className="flex items-center justify-center gap-3 text-center">
              <img
                src="/static/img/site-logo.png"
                alt=""
                className="h-16 w-16 object-contain"
              />
              <div className="min-w-0">
                <div
                  className="text-2xl font-semibold tracking-tight"
                  style={{
                    textShadow:
                      "0 0 14px rgba(6,182,212,0.48), 0 0 22px rgba(217,70,239,0.34)",
                    filter: "drop-shadow(0 0 8px rgba(255,255,255,0.28))"
                  }}
                >
                  <span className="text-cyan-200">Human</span>{" "}
                  <span className="text-fuchsia-200">Jukebox</span>
                </div>
              </div>
            </header>

            {error ? (
              <div className="mt-4 rounded-2xl bg-rose-500/15 ring-1 ring-rose-300/25 px-4 py-3 text-sm text-rose-50">{error}</div>
            ) : null}

            <form onSubmit={onSubmit} className="mt-4 space-y-3">
              <label className="block">
                <div className="text-sm text-slate-200">Email</div>
                <div className="mt-1 relative">
                  <input
                    id="loginEmail"
                    type="email"
                    autoComplete="email"
                    inputMode="email"
                    className="w-full rounded-2xl bg-slate-950/40 ring-1 ring-white/10 px-4 py-3 pr-12 text-base text-slate-50 outline-none focus:ring-2 focus:ring-cyan-300/40"
                    placeholder="you@example.com"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <i className="fa-regular fa-envelope absolute right-4 top-1/2 -translate-y-1/2 text-slate-300" />
                </div>
              </label>

              <label className="block">
                <div className="text-sm text-slate-200">Password</div>
                <div className="mt-1 relative">
                  <input
                    id="loginPassword"
                    type="password"
                    autoComplete="current-password"
                    className="w-full rounded-2xl bg-slate-950/40 ring-1 ring-white/10 px-4 py-3 pr-12 text-base text-slate-50 outline-none focus:ring-2 focus:ring-fuchsia-300/40"
                    placeholder="••••••••"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <i className="fa-solid fa-lock absolute right-4 top-1/2 -translate-y-1/2 text-slate-300" />
                </div>
              </label>

              <div className="flex justify-end pt-1">
                <Link
                  className="text-sm text-cyan-100 underline decoration-cyan-300/30 underline-offset-4"
                  to="/password-reset"
                >
                  Forgot password?
                </Link>
              </div>

              <button
                type="submit"
                disabled={busy}
                className="mt-2 w-full rounded-2xl bg-cyan-500/20 hover:bg-cyan-500/25 ring-1 ring-cyan-300/30 px-4 py-3 text-sm font-semibold text-cyan-50 disabled:opacity-60"
              >
                {busy ? "…" : "Sign in"}
              </button>

              <div className="pt-2 text-center text-sm text-slate-300">
                Don’t have an account?{" "}
                <Link className="text-fuchsia-100 underline decoration-fuchsia-300/30 underline-offset-4" to="/accounts/signup">
                  Sign up
                </Link>
              </div>
            </form>
          </section>
        </main>
      </div>
    </div>
  );
}
